/* Pés Felizes — legenda dos ícones de fase de crescimento: toque/clique abre a caixa com o nome da fase (o rato e o teclado são tratados por CSS). */
(() => {
  if (window.__pfFaseIcons) return;
  window.__pfFaseIcons = true;

  const closeAll = (except) => {
    document.querySelectorAll('.pf-fase-icons__item.is-open').forEach((li) => {
      if (li === except) return;
      li.classList.remove('is-open');
      li.querySelector('.pf-fase-icons__btn')?.setAttribute('aria-expanded', 'false');
    });
  };

  // Em fase de captura para que o toque no ícone não chegue ao link/handlers do card.
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest?.('.pf-fase-icons__btn');
      if (!btn) {
        closeAll(null);
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      const li = btn.closest('.pf-fase-icons__item');
      closeAll(li);
      const open = li.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    },
    true
  );

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll(null);
  });
})();
